module.exports = __webpack_public_path__ + "img/zhouchang_p.af120296.png";